import React, { useEffect, useState } from 'react'
import { Tab } from 'semantic-ui-react'
import { RowRender } from '../Controles/RowRender'
import { MonedaDetallePorcentajes } from './MonedaDetallePorcentajes'
import { OrdenesActivasRender } from './OrdenesActivas'
import { UltimosMovimientosRender } from './UltimosMovimientos'
import { NotificacionesMoneda } from './NotificacionesMoneda'
import { GraficaMoneda } from './GraficaMoneda'

export const MonedaDetalleRender = (params) => {

    const [internalState, setInternalState] = useState({
        MonedaDetalle: params.MonedaDetalle,
        MonedaDetalleInversion: 0,
    })

    //#region useEffect
    useEffect(() => { Load(); }, []);
    //#endregion
    //#region Metodos
    const Load = async () => {


    }
    //#endregion

    const OnCambiaHistorial = (historial) => {
        setInternalState((state) => ({ ...state, MonedaDetalleInversion: historial.Inversion, }));
    }

    const panes = [
        {
            menuItem: { key: 'Movimientos', icon: 'sort amount down', content: '' },
            render: () => <Tab.Pane attached={false} inverted >
                <UltimosMovimientosRender MonedaDetalle={internalState.MonedaDetalle} CambiaHistorial={OnCambiaHistorial} />
            </Tab.Pane>,
        }, {
            menuItem: { key: 'Ordenes', icon: 'file alternate outline', content: '' },
            render: () => <Tab.Pane attached={false} inverted>
                <OrdenesActivasRender MonedaDetalle={internalState.MonedaDetalle} />
            </Tab.Pane>,
        }, {
            menuItem: { key: 'Porcentajes', icon: 'percent', content: '' },
            render: () => <Tab.Pane attached={false} inverted>
                <MonedaDetallePorcentajes MonedaDetalle={internalState.MonedaDetalle} />
            </Tab.Pane>,
        }, {
            menuItem: { key: 'Notificaciones', icon: 'bell outline', content: '' },
            render: () => <Tab.Pane attached={false} inverted>
                <NotificacionesMoneda MonedaDetalle={internalState.MonedaDetalle} />
            </Tab.Pane>,
        }, {
            menuItem: { key: 'Grafica', icon: 'chart line', content: '' },
            render: () => <Tab.Pane attached={false} inverted>
                <GraficaMoneda MonedaDetalle={internalState.MonedaDetalle} />
            </Tab.Pane>,
        }
    ]

    return (
        <div className="principal-mobile-moneda-detalle animate__animated animate__backInRight">
            <RowRender Item={internalState.MonedaDetalle.Item} Inversion={internalState.MonedaDetalleInversion} MonedaDetalle={internalState.MonedaDetalle} AgregarOrden />
            <Tab className="principal-mobile-moneda-detalle-tab" menu={{ pointing: true }} panes={panes} inverted />
        </div>
    )
}
